var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionnaireRate = function SvgQuestionnaireRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FE8F24",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeWidth: 0.87,
    d: "m21.859 10.866-.723-.723a.137.137 0 0 0-.193 0L10.141 20.941a.137.137 0 0 0 0 .193l.723.723c.053.053.14.053.193 0l10.8-10.8a.133.133 0 0 0 .002-.191Zm-9.404 4.043a2.457 2.457 0 0 0 2.454-2.454A2.457 2.457 0 0 0 12.455 10 2.457 2.457 0 0 0 10 12.455a2.457 2.457 0 0 0 2.455 2.454Zm0-3.682a1.229 1.229 0 0 1 0 2.455c-.677 0-1.228-.55-1.228-1.227s.55-1.228 1.228-1.228Zm7.09 5.864a2.457 2.457 0 0 0-2.454 2.454A2.457 2.457 0 0 0 19.545 22 2.457 2.457 0 0 0 22 19.545a2.457 2.457 0 0 0-2.455-2.454Zm0 3.682a1.229 1.229 0 0 1 0-2.455c.677 0 1.228.55 1.228 1.227s-.55 1.228-1.228 1.228Z"
  }))));
};
export default SvgQuestionnaireRate;